import Progress from './progress'
export { ProgressType, ProgressProps } from './progress'
export default Progress
